import { Script, v2Script } from "../../types/custom_tests/script";

export const isV2Script = (input: Script): input is v2Script => input.version === "aim_reader";
